import React from 'react';

import PaymentMethodContainer from '@buyside/components/presentation/UserAccount/BillingInformation/PaymentMethod/paymentMethodContainer';
import BillingAddressContainer from '@buyside/components/presentation/UserAccount/BillingInformation/BillingAddress/billingAddressContainer';
import BillingHistoryContainer from '@buyside/components/presentation/UserAccount/BillingInformation/BillingHistory/billingHistoryContainer';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import Subscription from '@buyside/components/presentation/UserAccount/BillingInformation/Subscription/subscription';

import styles from './billingInformationShowPageStyles.scss';

const BillingInformation: React.FC<{}> = (): React.ReactElement => (
  <>
    <div className={styles.subsecTitle}>Billing Address</div>
    <ErrorBoundary pageName="your billing address">
      <BillingAddressContainer />
    </ErrorBoundary>
    <div className={styles.subsecTitle}>Payment Method</div>
    <ErrorBoundary pageName="your payment method">
      <div className={styles.paymentMethodContainer}>
        <PaymentMethodContainer />
      </div>
    </ErrorBoundary>
    <div className={styles.subsecTitle}>Billing History</div>
    <ErrorBoundary pageName="your billing history">
      <BillingHistoryContainer />
    </ErrorBoundary>
    <div className={styles.subsecTitle}>Subscription Auto-Renewal</div>
    <ErrorBoundary pageName="your subscriptions">
      <Subscription />
    </ErrorBoundary>
  </>
);

export default BillingInformation;
